import { FC, useEffect, useMemo } from 'react';
import useImpressionT2 from '@/tracks/useImpressionT2';
import { isSayWeeeApp } from '@/utils/weeeapp';
import { getAppContext } from '@/utils/weeeTracker/utils';

import { Sheet, SheetContent, SheetOverlay } from '@weee-fe/kunlun';

import RewardsSavingContent from '@/components/rewards/RewardsSaving/content';
import GiftCardIntro from '@/components/pdp/GiftCard/Intro/content';
import ThursdayLowerMinimum from './components/ThursdayLowerMinimum';

// Popup key
export enum ActivityKey {
  REWARDS_SAVING = 'total_saving_breakdown',
  GIFT_CARD_INTRO = 'gift_card_intro',
  THURSDAY_LOWER_MINIMUM = 'thursday_lower_minimum'
}
// Popup components
export const POPUP_COMPONENTS_MAP = {
  [ActivityKey.REWARDS_SAVING]: RewardsSavingContent,
  [ActivityKey.GIFT_CARD_INTRO]: GiftCardIntro,
  [ActivityKey.THURSDAY_LOWER_MINIMUM]: ThursdayLowerMinimum
};

type Props = {
  visible?: boolean;
  onCancel?: () => void;
  componentKey?: string;
  isPopup?: boolean; //显示弹窗样式，否则只返回弹窗内容
  className?: string;
  onSuccess?: () => void;
  url?: string;
  t?: any;
  lang?: string;
};

const Noop = () => <div></div>;

const SupportPopupWrapper: FC<Props> = props => {
  const { visible, componentKey, url, isPopup, onCancel } = props;
  const { popupImpression } = useImpressionT2();

  useEffect(() => {
    if (componentKey && visible && !!POPUP_COMPONENTS_MAP[componentKey]) {
      let baseTrackingParams = {
        mod_nm: componentKey,
        co: {
          action: 'view',
          name: componentKey,
          url: url || window.location.href
        }
      };
      if (isSayWeeeApp()) {
        const appParams = getAppContext();
        popupImpression(baseTrackingParams, { ...appParams });
      } else {
        popupImpression(baseTrackingParams);
      }
    }
  }, [componentKey, visible, url]);

  const Widget = useMemo(() => {
    const Component = POPUP_COMPONENTS_MAP[componentKey] || Noop;
    return Component;
  }, [componentKey]);

  if (isPopup) {
    return (
      <Sheet open={visible}>
        <SheetOverlay
          className="z-[1002]"
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            onCancel?.();
          }}
        />
        <SheetContent
          className="z-[1003]"
          style={{
            height: 'auto',
            overflow: 'hidden',
            borderTopLeftRadius: '32px',
            borderTopRightRadius: '32px'
          }}>
          <Widget {...props} />
        </SheetContent>
      </Sheet>
    );
  }
  return <Widget {...props} />;
};

export default SupportPopupWrapper;
